import { colors, fonts } from '@grupoboticario/flora-tokens/fidelidadeOBoticario/web/ds'

export const fidelidadeOBoticario = {
  colors,
  fonts,
}
